import React, { useEffect, useState } from "react";
import Input from "../../../../../../components/Elements/Input/Input";
import { Button, Select, Divider } from "antd";
import toast from "react-hot-toast";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import OrganizationDocumentsUpload from "./OrganizationDocumentsUpload";
import {
  fetchProfileData,
  updateOrganizationData,
} from "../../../../../../redux/ProfileSlice/profileSlice";
import { updateOrganizationName } from "../../../../../../redux/auth/authSlice";
import PopupCard from "../../../../../Auth/PopupCard";
import {
  appendJsonSection,
  appendProfileFiles,
  appendRegDocumentFiles,
  buildBillingPayload,
  buildOrganizationPayload,
  buildOrgContactsPayload,
  emptyRegDocState,
  isBillingEmailChangeRejected,
  regDocsFromProfile,
} from "../profileFormUtils";
import ContactDetails from "../ContactDetails/ContactDetails";
const countryCodes = [
  { label: "Turkey (+90)", value: "+90" },
  { label: "US (+1)", value: "+1" },
  { label: "UK (+44)", value: "+44" },
  { label: "IND (+91)", value: "+91" },
  { label: "AUS (+61)", value: "+61" },
  { label: "CAN (+1)", value: "+1" },
  { label: "GER (+49)", value: "+49" },
  { label: "FRA (+33)", value: "+33" },
  { label: "JAP (+81)", value: "+81" },
];

const countries = [
  { label: "Turkey", value: "Turkey" },
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "India", value: "India" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "Australia", value: "Australia" },
];

const splitContactNumber = (contactNumber = "") => {
  const matchedCountryCode = countryCodes.find(({ value }) =>
    contactNumber.startsWith(value),
  )?.value;

  return {
    countryCode: matchedCountryCode || "",
    phoneNumber: matchedCountryCode
      ? contactNumber.slice(matchedCountryCode.length)
      : contactNumber,
  };
};

// Small section wrapper — gives each block of the form a card feel
// without touching the existing color palette (white bg, gray borders).
const Section = ({ title, children }) => (
  <section className="mb-8 rounded-xl border border-gray-100 bg-white p-5 sm:p-6 shadow-sm">
    <div className="mb-5">
      <h3 className="text-base sm:text-lg font-semibold text-gray-800">
        {title}
      </h3>
    </div>
    {children}
  </section>
);

const OrganizationDetails = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  // shallowEqual keeps this component from re-rendering (and re-triggering
  // the hydration effect below) every time an unrelated field on the
  // `profile` slice changes — e.g. billingOtpSent/billingOtpVerified toggling
  // while the user types in the billing email field in ContactDetails.
  const { profileData, profileUpdateLoading } = useSelector(
    (state) => state.profile,
    shallowEqual,
  );
  const profile = Array.isArray(profileData) ? profileData[0] : profileData;

  const [billingDetails, setBillingDetails] = useState({
    organizationName: "",
    AddressDetails: {
      AddressLine: "",
      city: "",
      state: "",
      Country: "",
      Pincode: "",
    },
  });
  const [billingSameAsOrg, setBillingSameAsOrg] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  // Contact Details state (lifted from ContactDetails component)
  const [contactDetails, setContactDetails] = useState({
    contactPersonName: "",
    copyOfPassport: "",
    contactNumber: { countryCode: "", phoneNumber: "" },
    emailId: "",
  });
  const [passportFile, setPassportFile] = useState(null);
  const [otp, setOtp] = useState("");
  const [organizationDetails, setOrganizationDetails] = useState({
    organizationName: "",
    AddressDetails: {
      AddressLine: "",
      city: "",
      state: "",
      Country: "",
      Pincode: "",
    },
    organizationContactDetails: {
      website: "",
      contactPerson: "",
      contactNumber: {
        countryCode: "",
        phoneNumber: "",
      },
    },
    organizationemail: {
      email_id: "",
    },
    natureOfBusiness: "",
  });

  const [uploadOrganizationDocuments, setUploadOrganizationDocuments] =
    useState(emptyRegDocState());

  const handleOrganizationDocumentChange = (key, field, value) => {
    setUploadOrganizationDocuments((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const handleChangeOrganizationDetails = (e) => {
    setOrganizationDetails({
      ...organizationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleOrgAddressChange = (e) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      AddressDetails: {
        ...prev.AddressDetails,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleBillingAddressChange = (e) => {
    setBillingDetails((prev) => ({
      ...prev,
      AddressDetails: {
        ...prev.AddressDetails,
        [e.target.name]: e.target.value,
      },
    }));
  };

  const handleChangeBillingDetails = (e) => {
    setBillingDetails({
      ...billingDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleCountryCodeChange = (value) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      organizationContactDetails: {
        ...prev.organizationContactDetails,
        contactNumber: {
          ...prev.organizationContactDetails.contactNumber,
          countryCode: value,
        },
      },
    }));
  };

  const handlePhoneChange = (e) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      organizationContactDetails: {
        ...prev.organizationContactDetails,
        contactNumber: {
          ...prev.organizationContactDetails.contactNumber,
          phoneNumber: e.target.value,
        },
      },
    }));
  };

  const handleOrgEmailChange = (e) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      organizationemail: {
        ...prev.organizationemail,
        email_id: e.target.value,
      },
    }));
  };

  const handleContactPersonChange = (e) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      organizationContactDetails: {
        ...prev.organizationContactDetails,
        contactPerson: e.target.value,
      },
    }));
  };

  const handleWebsiteChange = (e) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      organizationContactDetails: {
        ...prev.organizationContactDetails,
        website: e.target.value,
      },
    }));
  };

  const handleCountryChange = (value) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      AddressDetails: {
        ...prev.AddressDetails,
        Country: value,
      },
    }));
  };

  const handleBillingCountryChange = (value) => {
    setBillingDetails((prev) => ({
      ...prev,
      AddressDetails: {
        ...prev.AddressDetails,
        Country: value,
      },
    }));
  };
  //handge organisation address same as billing address
  const handleBillingSameAsOrgChange = (e) => {
    const checked = e.target.checked;
    setBillingSameAsOrg(checked);

    if (checked) {
      setBillingDetails((prev) => ({
        ...prev,
        organizationName: organizationDetails.organizationName,
        AddressDetails: { ...organizationDetails.AddressDetails },
      }));
    } else {
      setBillingDetails({
        organizationName: "",
        AddressDetails: {
          AddressLine: "",
          city: "",
          state: "",
          Country: "",
          Pincode: "",
        },
      });
    }
  };

  useEffect(() => {
    if (billingSameAsOrg) {
      setBillingDetails((prev) => ({
        ...prev,
        organizationName: organizationDetails.organizationName,
        AddressDetails: { ...organizationDetails.AddressDetails },
      }));
    }
  }, [billingSameAsOrg, organizationDetails]);

  useEffect(() => {
    if (!showSuccessPopup) return;

    const timer = setTimeout(() => {
      setShowSuccessPopup(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [showSuccessPopup]);

  const handleSave = async () => {
    if (!user?._id) return;

    const savedBillingEmail = profile?.billing?.billingContact?.email || "";
    const emailChangeRejected = isBillingEmailChangeRejected(
      contactDetails.emailId,
      savedBillingEmail,
    );

    const formData = new FormData();

    // Build the organization payload, then fold in the fields the schema
    // now owns directly on `organization` rather than borrowing from the
    // client-level record: the free-text address line, the org's own
    // contact-person name, and its phone/email contact entries.
    const organizationPayload = buildOrganizationPayload(
      organizationDetails,
      uploadOrganizationDocuments,
    );
    organizationPayload.address = {
      ...(organizationPayload.address || {}),
      address: organizationDetails.AddressDetails.AddressLine || "",
    };
    organizationPayload.contactPerson =
      organizationDetails.organizationContactDetails.contactPerson || "";
    organizationPayload.contacts = buildOrgContactsPayload(organizationDetails);

    appendJsonSection(formData, "organization", organizationPayload);

    // Merge billing address + contact details into a single billing payload
    const billingPayload = buildBillingPayload(billingDetails, contactDetails, {
      savedBillingContactEmail: savedBillingEmail,
    });
    billingPayload.address = {
      ...(billingPayload.address || {}),
      address: billingDetails.AddressDetails.AddressLine || "",
    };
    appendJsonSection(formData, "billing", billingPayload);

    appendRegDocumentFiles(formData, uploadOrganizationDocuments);
    // Attach passport/govt-id file from ContactDetails
    appendProfileFiles(formData, { passportOrGovtIdFile: passportFile });

    try {
      const result = await dispatch(updateOrganizationData(formData)).unwrap();
      if (emailChangeRejected || result?.emailChangeRejected) {
        toast.error(
          "Saved, but billing email was not changed. Verify OTP first.",
        );
      } else {
        setShowSuccessPopup(true);
      }
      dispatch(
        updateOrganizationName(organizationDetails.organizationName.trim()),
      );
      setUploadOrganizationDocuments((prev) => {
        const cleared = { ...prev };
        Object.keys(cleared).forEach((key) => {
          cleared[key] = { ...cleared[key], file: null };
        });
        return cleared;
      });
      setPassportFile(null);
      const fetched = await dispatch(fetchProfileData(user._id)).unwrap();
      if (fetched) {
        const updatedProfile = Array.isArray(fetched) ? fetched[0] : fetched;
        const updatedOrg = updatedProfile?.organization;
        const updatedBillingContact =
          updatedProfile?.billing?.billingContact || {};
        if (updatedOrg) {
          setUploadOrganizationDocuments(regDocsFromProfile(updatedOrg));
        }
        setContactDetails((prev) => ({
          ...prev,
          copyOfPassport:
            updatedBillingContact.passportOrGovtId?.filePath ||
            updatedOrg?.passport?.filePath ||
            prev.copyOfPassport,
        }));
      }
    } catch (error) {
      toast.error(
        typeof error === "string"
          ? error
          : "Failed to save organization details",
      );
    }
  };

  // Hydrate local form state from the loaded profile.
  //
  // IMPORTANT: this is keyed on `profile?._id`, not on the `profile` object
  // itself. Redux slices commonly spread the whole slice on every reducer
  // update (e.g. `{ ...state, billingOtpSent: false }`), which produces a
  // *new* `profileData` reference even when the actual saved data hasn't
  // changed. If this effect depended on `profile` directly, any unrelated
  // slice update (like the OTP-reset dispatched on every keystroke in
  // ContactDetails) would re-run this effect and silently overwrite
  // whatever the user was actively typing with the last-saved values —
  // which is exactly the "fields go empty while typing" bug.
  //
  // Keying on the id means this only re-hydrates when a genuinely different
  // profile loads (initial load, or after fetchProfileData resolves with a
  // different id post-save/post-login), not on every incidental re-render.
  useEffect(() => {
    if (!profile?._id) {
      return;
    }

    const primaryContact =
      profile.contacts?.find((contact) => contact?.isPrimary) ||
      profile.contacts?.[0] ||
      {};
    // Organization's own contact list (organization.contacts) now carries
    // the phone/email entries; organization.contactPerson carries the name.
    const orgPrimaryContact =
      profile.organization?.contacts?.find((contact) => contact?.isPrimary) ||
      profile.organization?.contacts?.[0] ||
      {};
    const organizationAddress = profile.organization?.address || {};
    const billingAddress = profile.billing?.address || {};
    const phone = splitContactNumber(orgPrimaryContact.contactNumber);

    setOrganizationDetails({
      organizationName: profile.organization?.name || "",
      AddressDetails: {
        // Only read from organization.address — profile.location is a
        // separate, unrelated field and should never leak into this form.
        AddressLine: organizationAddress.address || "",
        city: organizationAddress.city || "",
        state: organizationAddress.state || "",
        Country: organizationAddress.country || "",
        Pincode: organizationAddress.pinCode || "",
      },
      organizationContactDetails: {
        website: profile.organization?.website || "",
        contactPerson: profile.organization?.contactPerson || "",
        contactNumber: {
          countryCode: phone.countryCode,
          phoneNumber: phone.phoneNumber,
        },
      },
      organizationemail: {
        // Only read from organization's own contact list — do not fall
        // back to profile.email, which belongs to a different scope.
        email_id: orgPrimaryContact.email || "",
      },
      natureOfBusiness: profile.organization?.natureOfBusiness || "",
    });

    setBillingDetails({
      organizationName: profile.billing?.organizationName || "",
      AddressDetails: {
        AddressLine: billingAddress.address || "",
        city: billingAddress.city || "",
        state: billingAddress.state || "",
        Country: billingAddress.country || "",
        Pincode: billingAddress.pinCode || "",
      },
    });

    // Populate contact details state from profile
    const billingContact = profile.billing?.billingContact || {};
    const contactPhone = {
      countryCode: profile.billing?.countryCode || "",
      phoneNumber:
        billingContact.contactNumber || profile.billing?.contactNumber || "",
    };
    setContactDetails({
      contactPersonName:
        billingContact.contactPersonName ||
        profile.billing?.contactPersonName ||
        "",
      copyOfPassport:
        billingContact.passportOrGovtId?.filePath ||
        profile.organization?.passport?.filePath ||
        "",
      contactNumber: contactPhone,
      // Only billing-scoped email fields — do not fall back to
      // primaryContact.email (that's the general contacts list, a
      // different key entirely from billing.billingContact).
      emailId:
        billingContact.emailVerification?.pendingEmail ||
        billingContact.email ||
        profile.billing?.email ||
        "",
    });

    setUploadOrganizationDocuments(regDocsFromProfile(profile.organization));
  }, [profile?._id]);

  return (
    <div
      style={{ backgroundColor: "#fff", borderRadius: "10px" }}
      className="py-4"
    >
      <div className="px-4 sm:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6">
          Organization Profile
        </h2> */}

        {/* Organization Section */}
        <Section title="Basic Organization Information">
          <div className="mb-6">
            <label className="block font-normal text-gray-500 mb-2">
              Organization Name
            </label>
            <Input
              type="text"
              name="organizationName"
              value={organizationDetails.organizationName}
              onChange={handleChangeOrganizationDetails}
              className="w-full max-w-md"
              variant="secondary"
            />
          </div>

          <Divider className="my-6" />

          {/* Address Details */}
          <div>
            <label className="block font-normal text-gray-500 mb-4">
              Address Details
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
              <Input
                type="text"
                name="AddressLine"
                value={organizationDetails.AddressDetails.AddressLine}
                onChange={handleOrgAddressChange}
                className="w-full"
                placeholder="Address Line"
                variant="secondary"
              />
              <Input
                type="text"
                name="city"
                value={organizationDetails.AddressDetails.city}
                onChange={handleOrgAddressChange}
                className="w-full"
                placeholder="City"
                variant="secondary"
              />
              <Input
                type="text"
                name="state"
                value={organizationDetails.AddressDetails.state}
                onChange={handleOrgAddressChange}
                className="w-full"
                placeholder="State"
                variant="secondary"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <select
                value={organizationDetails.AddressDetails.Country}
                onChange={(e) => handleCountryChange(e.target.value)}
                className="w-full border-b-[2px] border-gray-300 focus:outline-none py-2 bg-transparent"
              >
                <option value="">Select a country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </select>
              <Input
                type="text"
                name="Pincode"
                value={organizationDetails.AddressDetails.Pincode}
                onChange={handleOrgAddressChange}
                className="w-full"
                placeholder="Pin Code"
                variant="secondary"
              />
            </div>
          </div>
        </Section>

        {/* Upload Documents Section */}
        <Section title="Registration Details">
          <OrganizationDocumentsUpload
            uploadDocuments={uploadOrganizationDocuments}
            handleDocumentChange={handleOrganizationDocumentChange}
          />
        </Section>

        {/* Organization Contact Details */}
        <Section title="Organization Contact Information">
          <div className="mb-5">
            <label className="block font-normal text-gray-500 mb-2">
              Official Organization Email
            </label>
            <Input
              type="email"
              placeholder="Email Id"
              className="w-full max-w-md"
              value={organizationDetails.organizationemail.email_id}
              onChange={handleOrgEmailChange}
              variant="secondary"
            />
          </div>
          <div className="mb-5">
            <label className="block font-normal text-gray-500 mb-2">
              Official Organization Phone
            </label>
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <div className="flex gap-2 w-full sm:w-auto">
                <Select
                  showSearch
                  placeholder="Code"
                  className="w-28 flex-shrink-0"
                  options={countryCodes}
                  value={
                    organizationDetails.organizationContactDetails.contactNumber
                      .countryCode || undefined
                  }
                  onChange={handleCountryCodeChange}
                />
                <Input
                  type="text"
                  placeholder="Phone Number"
                  className="flex-1 min-w-0"
                  value={
                    organizationDetails.organizationContactDetails.contactNumber
                      .phoneNumber
                  }
                  onChange={handlePhoneChange}
                  variant="secondary"
                />
              </div>
            </div>
          </div>
          <div className="mb-5">
            <label className="block font-normal text-gray-500 mb-2">
              Website
            </label>
            <Input
              type="url"
              value={organizationDetails.organizationContactDetails.website}
              onChange={handleWebsiteChange}
              className="w-full max-w-md"
              placeholder="https://example.com"
              variant="secondary"
            />
          </div>
          <div className="mb-2">
            <label className="block font-normal text-gray-500 mb-2">
              Organization Contact Person
            </label>
            <Input
              type="text"
              value={
                organizationDetails.organizationContactDetails.contactPerson
              }
              onChange={handleContactPersonChange}
              className="w-full max-w-md"
              placeholder="Contact Person"
              variant="secondary"
            />
          </div>
        </Section>

        {/* Nature of Business */}
        <Section title="Nature of Business">
          <label className="block font-normal text-gray-500 mb-4">
            Explain about the nature of business
          </label>
          <textarea
            value={organizationDetails.natureOfBusiness}
            onChange={(e) =>
              setOrganizationDetails((prev) => ({
                ...prev,
                natureOfBusiness: e.target.value,
              }))
            }
            className="border-2 rounded-xl w-full h-28 focus:outline-none p-4 resize-none"
          />
        </Section>

        {/* Billing Information */}
        <Section title="Billing Information">
          <div className="mb-5 flex items-center gap-2">
            <input
              type="checkbox"
              id="billingSameAsOrg"
              checked={billingSameAsOrg}
              onChange={handleBillingSameAsOrgChange}
              className="w-4 h-4 cursor-pointer"
            />
            <label
              htmlFor="billingSameAsOrg"
              className="font-normal text-gray-600 cursor-pointer text-sm"
            >
              Billing address same as organization address
            </label>
          </div>

          <div className="mb-6">
            <label className="block font-normal text-gray-500 mb-2">
              Organization Name
            </label>
            <Input
              type="text"
              name="organizationName"
              value={billingDetails.organizationName}
              onChange={handleChangeBillingDetails}
              className="w-full max-w-md"
              variant="secondary"
              disabled={billingSameAsOrg}
            />
          </div>

          <div>
            <label className="block font-normal text-gray-500 mb-4">
              Billing Contact Details
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
              <Input
                type="text"
                name="AddressLine"
                value={billingDetails.AddressDetails.AddressLine}
                onChange={handleBillingAddressChange}
                className="w-full"
                placeholder="Address Line"
                variant="secondary"
                disabled={billingSameAsOrg}
              />
              <Input
                type="text"
                name="city"
                value={billingDetails.AddressDetails.city}
                onChange={handleBillingAddressChange}
                className="w-full"
                placeholder="City"
                variant="secondary"
                disabled={billingSameAsOrg}
              />
              <Input
                type="text"
                name="state"
                value={billingDetails.AddressDetails.state}
                onChange={handleBillingAddressChange}
                className="w-full"
                placeholder="State"
                variant="secondary"
                disabled={billingSameAsOrg}
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <select
                className="w-full border-b-[2px] border-gray-300 focus:outline-none py-2 bg-transparent disabled:opacity-60"
                value={billingDetails.AddressDetails.Country}
                onChange={(e) => handleBillingCountryChange(e.target.value)}
                disabled={billingSameAsOrg}
              >
                <option value="">Select a country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </select>
              <Input
                type="text"
                name="Pincode"
                value={billingDetails.AddressDetails.Pincode}
                onChange={handleBillingAddressChange}
                className="w-full"
                placeholder="Pin Code"
                variant="secondary"
                disabled={billingSameAsOrg}
              />
            </div>
          </div>

          {/* Contact Details – part of Billing Information */}
          <Divider className="my-6" />
          <div>
            <label className="block font-normal text-gray-500 mb-4">
              Billing Contact Details
            </label>
            <ContactDetails
              contactDetails={contactDetails}
              setContactDetails={setContactDetails}
              passportFile={passportFile}
              setPassportFile={setPassportFile}
              otp={otp}
              setOtp={setOtp}
            />
          </div>
        </Section>

        {/* Save Button */}
        <div className="text-center my-8">
          <Button
            type="secondary"
            onClick={handleSave}
            loading={profileUpdateLoading}
            className="text-white bg-[#06513D] hover:bg-[#387464] text-sm px-6 sm:px-10 py-3 sm:py-5 w-full sm:w-auto"
          >
            Save
          </Button>
        </div>
      </div>
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center pointer-events-none">
          <PopupCard
            type="success"
            title="Success"
            message="Profile updated successfully"
            onClose={() => setShowSuccessPopup(false)}
          />
        </div>
      )}
    </div>
  );
};

export default OrganizationDetails;
